/* eslint-disable max-len */

import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

type Props = CommonIconProps;

export const TemplateGalleryTicketingIcon: FC<Props> = ({ className }) => (
  <svg className={className} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.7346 12.3363C20.4462 12.3363 20.3783 12.7944 20.3783 13.1337C20.3783 14.5589 20.3105 19.2416 20.3105 19.8184C20.3105 20.3104 20.2765 20.7685 19.8524 20.7685C19.7675 20.7685 16.4252 20.7685 13.0828 20.7855C9.74044 20.7855 6.38111 20.8025 6.31325 20.8025C5.88909 20.8025 5.85515 20.3444 5.85515 19.8524C5.85515 19.2755 5.75335 14.5928 5.75335 13.1676C5.75335 12.8283 5.68549 12.3702 5.39706 12.3702C5.10863 12.3702 5.0238 12.6586 5.00684 13.1676C5.00684 13.4221 5.0238 19.5809 5.0238 20.6158C5.0238 21.6508 6.00785 21.7017 6.14358 21.7017C6.22841 21.7017 9.87617 21.7017 13.0828 21.6847C16.2894 21.6847 19.9542 21.6678 20.022 21.6678C20.1578 21.6678 21.1418 21.6169 21.1418 20.5819C21.1418 19.547 21.1248 13.3882 21.1248 13.1337C21.1079 12.6247 21.023 12.3363 20.7346 12.3363Z"
      fill="currentColor"
    />
    <path
      d="M20.2427 6.55069H17.2397V5.61755C17.2397 5.38002 17.053 5.17642 16.7985 5.17642H15.6957C15.4582 5.17642 15.2546 5.36305 15.2546 5.61755V6.55069L10.8264 6.56766V5.63451C10.8264 5.39698 10.6398 5.19339 10.3853 5.19339H9.28247C9.04494 5.19339 8.84134 5.38002 8.84134 5.63451V6.56766H5.8383C5.34627 6.56766 4.95605 6.95789 4.95605 7.44991V11.0637L21.108 11.0298V7.41598C21.125 6.94092 20.7178 6.55069 20.2427 6.55069Z"
      fill="currentColor"
    />
  </svg>
);
